import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ISubject } from 'src/app/model/service/isubject';
import { BASIS_CATEGORY_DEF_NAMES } from 'src/app/model/view/iqualification-basis-def';
import { IStepDataDef } from 'src/app/model/view/iqualification-def';
import { environment } from 'src/environments/environment';
import { OrientationRepositoryService } from '../qualification/orientation-repository.service';
import { HiddenSubjectsDefinitions } from './hiddensubjects-definitions';

@Injectable({
  providedIn: 'root',
})
export class SyllabusService {

  constructor(
    private client: HttpClient,
    private orientationRepository: OrientationRepositoryService) { }

  private static isHiddenSubject(subject: ISubject): boolean {
    return HiddenSubjectsDefinitions.subjects.includes(subject.code);
  }
  /**
   * Get all vocational subjects for the given study path.
   * @param schoolingType type of schooling
   */
  public getVocationalSubjects(schoolingType: string): Observable<IStepDataDef[]> {
    return this.getSubjectsByTypeOfSchooling(schoolingType)
      .pipe(map((subjects: ISubject[]) =>
        subjects.filter((s) => s.categories && s.categories.length > 0 && s.categories[0].code === BASIS_CATEGORY_DEF_NAMES.VOCATIONAL
          && !SyllabusService.isHiddenSubject(s)),
      ));
  }

  /**
   * Get all non-vocational subjects for the given qualification.
   * @param schoolingType type of schooling
   */
  public getNonVocationalSubjects(schoolingType: string): Observable<IStepDataDef[]> {
    return this.getSubjectsByTypeOfSchooling(schoolingType)
      .pipe(map((subjects: ISubject[]) =>
        subjects.filter((s) =>
          !s.categories || s.categories.length === 0 || (s.categories[0].code !== BASIS_CATEGORY_DEF_NAMES.VOCATIONAL
          && s.categories[0].code !== BASIS_CATEGORY_DEF_NAMES.SUBJECT_AREA)),
      ));
  }

  public getSubjectAreaSubjects(schoolingType: string, extended?: boolean): Observable<IStepDataDef[]> {
    const include = extended ? ['GRSAMOT01', 'GRSAVAR01'] : [];
    return this.getSubjectsByTypeOfSchooling(schoolingType)
      .pipe(map((subjects: ISubject[]) =>
        subjects.filter((s) =>
          (s.categories && s.categories.length > 0 && s.categories[0].code === BASIS_CATEGORY_DEF_NAMES.SUBJECT_AREA)
          || include.indexOf(s.code) !== -1),
      ));
  }

  /**
   * Get available special school orientations.
   */
  public getSpecialSchoolOrientations(): Observable<IStepDataDef[]> {
    return of<IStepDataDef[]>(this.orientationRepository.specialSchoolOrientations);
  }

  private getSubjectsByTypeOfSchooling(schoolingType: string): Observable<IStepDataDef[]> {
    const paramter = { type: schoolingType };
    return this.client.get<ISubject[]>(environment.baseUrl + '/v1/getSubjectsByTypeOfSchooling', { params: paramter });
  }
}
